import { render, staticRenderFns } from "./videoCamera.vue?vue&type=template&id=6eafc025&scoped=true"
import script from "./videoCamera.vue?vue&type=script&lang=js"
export * from "./videoCamera.vue?vue&type=script&lang=js"
import style0 from "./videoCamera.vue?vue&type=style&index=0&id=6eafc025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eafc025",
  null
  
)

export default component.exports